import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const list = (accessToken) => {
  return axios.get(apiUrl + "/pricing/all/1/1000", { headers: authHeader(accessToken) });
};

export const get = (id, accessToken) => {
  return axios.get(apiUrl + "/pricing/" + id, { headers: authHeader(accessToken) });
};

export const create = (pricing, accessToken) => {
  console.log("create pricing: ", pricing);
  return axios.post(apiUrl + "/pricing", pricing, { headers: authHeader(accessToken) });
};

export const edit = (id, pricing, accessToken) => {
  return axios.put(apiUrl + "/pricing/" + id, pricing, {
    headers: authHeader(accessToken),
  });
};

export const deletePricing = (id, accessToken) => {
  return axios.delete(apiUrl + "/pricing/" + id, { headers: authHeader(accessToken) });
};
